// ### Imports
// * Import lib
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTheme } from "@emotion/react";

// * Import custom components]

// * Import data & utils
import role_img_light from "../../../assets/images/signup_images/light_theme/role_img.svg";
import role_img_dark from "../../../assets/images/signup_images/dark_theme/role_img_dark.svg";

// * Import kits
import Box from "../../kit/Box";
import Button from "../../kit/Button";

// * Import actions

// * Import styles
import { accountSetupStyles } from "../../theme/style";
import { postUserInfo } from "../../services/api";
import Loader from "../../components/Loader/Loader";
import { useNavigate } from "react-router-dom";
import { updateSnackbar } from "../../redux/slice/snackbarSlice";
import JobRoleContent from "./JobRoleContent";
import { getThemeName } from "../../utils/utils";

// # Component
const JobRole = ({
  setActiveScreen,
  templateData,
  activeStep,
  setActiveStep,
  setDataLoading,
}) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const classes = accountSetupStyles(theme);
  const navigate = useNavigate();
  const [isUpdateApiInProgress, setIsUpdateApiInProgress] = useState(false);

  const selectedJobRole = useSelector((state) => state.accountSetup.jobRole);
  const userInfoApiPayload = useSelector((state) => ({
    name: state.auth.metadata.name,
    email: state.auth.metadata.email,
    role: state.auth.metadata.role,
    account_info: {
      job_role: state.accountSetup.jobRole,
      function: state.accountSetup.functions,
      regions: state.accountSetup.geography,
    },
  }));

  const handleBack = () => {
    setActiveScreen((prev) => prev - 1);
    setActiveStep(activeStep - 1);
  };

  const handleNext = () => {
    setIsUpdateApiInProgress(true);
    setDataLoading(false);
    const updateUserInfoApi = async (payload) => {
      try {
        await postUserInfo({ payload });
        navigate("/discover");
        setIsUpdateApiInProgress(false);
      } catch (error) {
        setIsUpdateApiInProgress(false);
        dispatch(
          updateSnackbar({ message: "Update failed. Please try again." })
        );
      }
    };
    updateUserInfoApi(userInfoApiPayload);
  };
  const isDarkMode = useSelector((state) => state.selections.isDarkMode);
  const role_img = getThemeName(isDarkMode) ? role_img_dark : role_img_light;

  // # JSX
  return (
    <>
      {isUpdateApiInProgress && <Loader />}
      {!isUpdateApiInProgress && (
        <div
          className={classes.setupCardContainer}
          style={{ height: "100%", display: "flex", flexDirection: "row" }}
        >
          <Box className={classes.container} sx={{ alignItems: "center" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                height: "calc(100vh - 50px)%",
                overflow: "auto",
                paddingBottom: theme.size[50],
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  position: "absolute",
                  top: "120px",
                  paddingTop: "80px",
                }}
              >
                <JobRoleContent templateData={templateData} />
              </div>
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  position: "absolute",
                  bottom: theme.size[30],
                  background: theme.palette.tertiary.light,
                  zIndex: "1000",
                  padding: "20px 5px 0 23rem",
                }}
              >
                <Button
                  disableRipple
                  className={classes.accountSetupButtonOutlined}
                  onClick={handleBack}
                >
                  Back
                </Button>
                <Button
                  disableRipple
                  className={classes.accountSetupButtonFilled}
                  onClick={handleNext}
                  disabled={!selectedJobRole || isUpdateApiInProgress}
                >
                  {isUpdateApiInProgress ? <Loader /> : "Finish"}
                </Button>
              </Box>
            </div>
          </Box>
          <Box sx={{ height: "100%", width: "40%", position: "relative" }}>
            <img
              src={role_img}
              alt="error"
              style={{ height: "100%", position: "absolute", right: "-60px" }}
            />
          </Box>
        </div>
      )}
    </>
  );
};

// # Exports
export default JobRole;
